import apiClient from './axiosInterceptor';


export const httpClient = {

    get: async (url: string) => {
        const headers: any = {
            'Content-Type': 'application/json'
        }

        const config: any = {
            headers: headers
        }
        const json: any = await apiClient.get(url, config);
        if (json.data.Success === false) {
            throw json.data;
        } else {
            return json;
        }
    },

    post: async (url: string, data: any) => {
        const options = (data) ? JSON.stringify(data) : undefined
        const headers: any = {
            'Content-Type': 'application/json'
        }

        const json: any = await apiClient.post(url, options, { headers });
        if (json.data.Success === false) {
            throw json.data;
        } else {
            return json;
        }
    },

    postWithCancel: async (url: string, data: any, abortObj: AbortController) => {

        const options = (data) ? JSON.stringify(data) : undefined

        const headers: any = {
            'Content-Type': 'application/json'
        }

        const axiosConfig: any = {
            headers
        }

        if (abortObj) {
            axiosConfig.signal = abortObj.signal;
        }

        const json: any = await apiClient.post(url, options, axiosConfig);
        if (json.data.Success === false) {
            throw json.data;
        } else {
            return json;
        }
    }

};